import { words } from 'lodash'

type Options = {
	titleCased?: boolean
}

/**
 * Render an identifier, such as an enum value to a display-value. Works for
 * multiple formats.
 *
 * @example
 * ```ts
 * enum Status {
 * 	IsSent = 'is-sent',
 * 	InProgress = 'IN_PROGRESS',
 * 	DidNotSucceed = 'did_not_succeed',
 * }
 *
 * renderIdentifier(STATUS.IsSent)
 * // returns 'Is sent'
 * renderIdentifier(STATUS.InProgress)
 * // returns 'In progress'
 * renderIdentifier(STATUS.DidNotSucceed)
 * // returns 'Did not succeed'
 * ```
 */
export const renderIdentifier = (value: string, { titleCased = false }: Options = {}): string =>
	words(value)
		.map((word, index) =>
			index === 0 || titleCased ? word[0].toUpperCase() + word.substring(1).toLowerCase() : word.toLowerCase(),
		)
		.join(' ')
